/**
 * @param {HTMLElement} sourceElement
 * @param {HTMLInputElement} targetInput
 */
function redirectClickToInput(sourceElement, targetInput) {
	sourceElement.addEventListener('click', e => {
		targetInput.dispatchEvent(new MouseEvent('click', e));
	})
}

export {redirectClickToInput}
